import React from 'react';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import { Button, Input, Dropdown } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class Addpricemenu extends React.Component {

  state = {
    DiscountLevel: [], item: []
  }

  convertIntoNumber = (value) => {
    try {
        value = Number(value);
    } catch (error) {
        value = 0;
    }
    return value;
  }

  makeDecimalPoints = (value) => {
      try {
        value = value.toFixed(2);
      } catch (error) {
        value = 0;
      }
      return value;
  }

    handleChange = (name, id) => event => {
        let item = this.state.item;
        item.map((c) => {
            if (id == c.id) {
                c.discount = event.target.value;
                let mrp = this.convertIntoNumber(c.mrp);
                c.discountrs = (mrp * event.target.value)/100;
                c.total = c.mrp - c.discountrs;
            }
        })
        this.setState({ item });
    };

    partcode = (id, event) => {
        let item = this.state.item;
        let partno = event.target.value.split('->')[0];
        let brand = event.target.value.split('->')[2];
        let { NoDiscountParts } = this.props;
        NoDiscountParts.map((c) => {
            if (c.partno == partno && c.brand_name == brand) {
                item.map((d) => {
                    if (d.id == id) {
                        d.dropdown = event.target.value;
                        d.discount = 0; d.partno = partno;
                        d.brand_name = c.brand_name;
                        d.dnp = c.dnp;
                        d.mrp = c.mrp;
                        d.brand_id = c.brand_id;
                    }
                })
            }
        })
        this.setState({ item })
    }

    addItem = () => {
        let item = this.state.item;
        let id = 0;
        item.map((c) => {
            id = c.id;
        })
        id = id + 1;
        item.push({ id })
        this.setState({ item })
    }

    delete = (id) => {
        let item = this.state.item;
        let newItem = [];
        item.map((c) => {
           if (c.id != id) {
                newItem.push(c)
           }
        })
        let ids = 0;
        newItem.map((c) => {
            ids = ids + 1;
            c.id = ids;
        })
        this.setState({ item: newItem })
    }

    submit = () => {
        let context = this;
        let item = this.state.item;
        let mid = this.props.mid;
        if (!mid) {
            alert('Select Price Level!!!');
            return;
          }
        context.setState({ load: true, message: 'Getting Discount Level!!!' })
        $.ajax({
            type: 'POST', data: { mid, item: JSON.stringify(item) }, 
            url: Server() + 'WebMaster/DiscountMenu/AddParts.php',
            success: function(data) {
                if (data == 1) {
                    context.setState({ item: [], DiscountMasterDialog: false })
                    context.props.refresh();
                    context.props.refreshSpares();
                }
                else {
                    alert('Error')
                }
            },
            error: function(e) {
            alert('Try again!!')
            context.setState({ load: false });
            }
        });

    }


    removeDuplicate = (spares) => {
        spares = spares.filter((v,i,a)=>a.findIndex(t=>(t.part_id === v.part_id))===i)
        return spares;
    }
    

  render() {
    let { item, DiscountMasterDialog } = this.state;
    let { NoDiscountParts } = this.props;
    NoDiscountParts = this.removeDuplicate(NoDiscountParts);
    let i = 1;
    return (
      <div>
        <Button onClick={ () => this.setState({ DiscountMasterDialog: true })}>Add Parts</Button>
        <Dialog onClose={ () => this.setState({ DiscountMasterDialog: false }) } fullWidth={true} maxWidth={'md'} open={DiscountMasterDialog} aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Add Discount Parts"}</DialogTitle>
            <DialogContent>
                <table width='100%' id='emp_table'>
                    <tr id='tableheader'>
                        <th id='tablecolumn'><b>S.No</b></th>
                        <th id='tablecolumn'><b>Partno</b></th>
                        <th id='tablecolumn'><b>Brand</b></th>
                        <th id='tablecolumn'><b>DNP</b></th>
                        <th id='tablecolumn'><b>MRP</b></th>
                        <th id='tablecolumn'><b>Discount</b></th>
                        <th id='tablecolumn'><b>Discont Rs</b></th>
                        <th id='tablecolumn'><b>Total</b></th>
                        <th id='tablecolumn'><b>Action</b></th>
                    </tr>
                    {
                        item.map((c) => {
                            return(
                            <tr>
                                <td>{i++}</td>
                                <td>
                                    <datalist id="suggestionspartno">
                                        {NoDiscountParts.map((c) => {
                                            return (
                                                <option id='box'>{c.partno+'->'+c.spare_name+'->'+c.brand_name}</option>
                                            )
                                        })}
                                    </datalist>
                                    <input style={{height: 35, width: '100%'}} 
                                    onChange={ (event) => this.partcode(c.id, event)} autoComplete="on"
                                    list="suggestionspartno" value={c.dropdown} />
                                </td>
                                <td>{c.brand_name}</td>
                                
                                <td>{c.dnp}</td>
                                <td>{c.mrp}</td>
                                <td><Input type="number" onChange={this.handleChange('name', c.id)} placeholder='Discount Per(%)' fluid value={c.discount} /></td>
                                <td>{this.makeDecimalPoints(c.discountrs)}</td>
                                <td>{this.makeDecimalPoints(c.total)}</td>
                                <td onClick={ () => this.delete(c.id)}><center>Delete</center></td>
                            </tr>
                            )
                        })
                    }
              </table>
              <center><Button onClick={this.addItem}>Add</Button></center>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => this.setState({ DiscountMasterDialog: false }) }>Close</Button>
              <Button onClick={this.submit}>Submit</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Addpricemenu;
